import React from "react";
import { string, array, shape, arrayOf, object, number } from "prop-types";
import cx from "classnames";

const propTypes = {
  results: arrayOf(
    shape({
      imageSrcWide: string,
      imageSrcSquare: string,
      title: string,
      clients: array,
      taxonomy: array,
      contentUrl: string,
    }),
  ),
  focusRef: object,
  focusItem: number,
};

const CaseStudyGrid = (props) => {
  const { results, focusRef, focusItem } = props;

  if (!results || results.length < 1) {
    return null;
  }

  return (
    <ul className="case-study-grid">
      {results.map((result, i) => {
        const tall = (i + 7) % 8 === 0 || (i + 4) % 8 === 0;
        const {
          key,
          imageSrcWide,
          imageSrcSquare,
          clients,
          contentUrl,
          title,
          body,
          taxonomy,
        } = result;

        return (
          <li key={key} className="case-study-grid__result">
            {((imageSrcSquare && tall) || (!tall && imageSrcWide)) && (
              <div
                className={cx("case-study-grid__media", {
                  "case-study-grid__media--tall": tall,
                })}
                onClick={() => (window.location = contentUrl)}
              >
                <img
                  alt=""
                  srcSet={tall ? imageSrcSquare : imageSrcWide}
                  sizes="770px"
                  loading={i < 2 ? "eager" : "lazy"}
                />
              </div>
            )}
            {clients && clients.length >= 1 && (
              <div className="case-study-grid__client">{clients[0]}</div>
            )}
            <div className="case-study-grid__title">
              <a
                ref={focusRef && focusItem === i ? focusRef : null}
                href={contentUrl}
              >
                {title}
              </a>
            </div>
            {body && (
              <div
                className="case-study-grid__description"
                dangerouslySetInnerHTML={{ __html: body }}
              />
            )}
            {taxonomy && (
              <div className="case-study-grid__content-types">
                {taxonomy.map((type) => (
                  <div key={type.text} className="case-study-grid__ct-item">
                    {type.text}
                  </div>
                ))}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
};
CaseStudyGrid.propTypes = propTypes;
export default React.memo(CaseStudyGrid);
